<div class="login-form-container cf-flex-column cf-gap-20">
  <app-entity-editor
    *ngIf="loginEntity"
    class="cf-fill"
    [entity]="loginEntity"
    [entityForm]="loginForm"
    (propertyChange)="propertyChanged($event)"
  ></app-entity-editor>
</div>
